import { useContext } from 'react';
import { type QuickView, QuickViewContext } from './index.tsx';

const useQuickView = (): QuickView => {
    const context = useContext(QuickViewContext);
    return context || {};
};

export default useQuickView;
